/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  IssuanceProfileChoice,
  IssuanceProfileChoice$inboundSchema,
} from "./issuanceprofilechoice.js";

/**
 * The upstream credentials a headless caller's sessions use: an OAuth client or a workload subject that cannot choose in a browser. Each new session gets the choices that still validate; a token request may name its own instead.
 */
export type IssuanceProfile = {
  /**
   * The credential for each MCP server.
   */
  choices: Array<IssuanceProfileChoice>;
  /**
   * The profile id.
   */
  id: string;
  /**
   * The profile's name.
   */
  name: string;
  /**
   * When the profile last changed.
   */
  updatedAt: Date;
  /**
   * The OAuth client the profile applies to, for a client.
   */
  userSessionClientId?: string | undefined;
  /**
   * The sign-in the caller's sessions come from.
   */
  userSessionIssuerId: string;
  /**
   * The workload issuer, for a workload subject.
   */
  workloadIssuerId?: string | undefined;
  /**
   * The workload subject, for a workload.
   */
  workloadSubject?: string | undefined;
};

/** @internal */
export const IssuanceProfile$inboundSchema: z.ZodMiniType<
  IssuanceProfile,
  unknown
> = z.pipe(
  z.object({
    choices: z.array(IssuanceProfileChoice$inboundSchema),
    id: z.string(),
    name: z.string(),
    updated_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    user_session_client_id: z.optional(z.string()),
    user_session_issuer_id: z.string(),
    workload_issuer_id: z.optional(z.string()),
    workload_subject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "updated_at": "updatedAt",
      "user_session_client_id": "userSessionClientId",
      "user_session_issuer_id": "userSessionIssuerId",
      "workload_issuer_id": "workloadIssuerId",
      "workload_subject": "workloadSubject",
    });
  }),
);

export function issuanceProfileFromJSON(
  jsonString: string,
): SafeParseResult<IssuanceProfile, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => IssuanceProfile$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'IssuanceProfile' from JSON`,
  );
}
